import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {JobTitleFieldComponent} from './job-title-field.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule, MatInputModule} from '@angular/material';
import {JobTitleDBService} from '../../@db/job-title-db.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
  ],
  providers: [JobTitleDBService],
  declarations: [JobTitleFieldComponent],
  exports: [JobTitleFieldComponent],
})
export class JobTitleFieldModule {
}
